import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/** Modo do painel do workflow. Fica na URL para sobreviver a recarga e navegacao. */
export type ShiftView = "live" | "shifts" | "comparison";
export const SHIFT_VIEW_PARAM = "visao";
const encoded: Record<ShiftView, string | null> = { live: null, shifts: "turnos", comparison: "comparativo" };

export function parseShiftView(value: string | null): ShiftView {
  return value === "turnos" ? "shifts" : value === "comparativo" ? "comparison" : "live";
}
export function isLocalDate(value: string | null | undefined): value is string {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value) || value < "0001-01-01" || value > "9998-12-31") return false;
  const at = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(at) && new Date(at).toISOString().slice(0, 10) === value;
}
/** Aritmetica de data civil, sem fuso: a data local ja vem do calendario. */
export function addLocalDays(date: string, days: number): string {
  return new Date(Date.parse(`${date}T00:00:00Z`) + days * 86400_000).toISOString().slice(0, 10);
}

export interface ShiftUrlPatch { view?: ShiftView; occurrenceId?: string | null; date?: string | null }
export function useShiftUrlState() {
  const [params, setParams] = useSearchParams();
  const view = parseShiftView(params.get(SHIFT_VIEW_PARAM));
  const occurrenceId = params.get("turno");
  const rawDate = params.get("data");
  const date = isLocalDate(rawDate) ? rawDate : null;
  const update = useCallback((patch: ShiftUrlPatch) => {
    // Replace: navegar entre turnos nao deve prender o botao voltar do navegador.
    setParams(previous => {
      const next = new URLSearchParams(previous);
      if (patch.view !== undefined) {
        const value = encoded[patch.view];
        if (value) next.set(SHIFT_VIEW_PARAM, value); else next.delete(SHIFT_VIEW_PARAM);
        if (patch.view !== "shifts") { next.delete("turno"); next.delete("data"); }
      }
      if (patch.occurrenceId !== undefined) { if (patch.occurrenceId) next.set("turno", patch.occurrenceId); else next.delete("turno"); }
      if (patch.date !== undefined) { if (patch.date) next.set("data", patch.date); else next.delete("data"); }
      return next;
    }, { replace: true });
  }, [setParams]);
  return { view, occurrenceId, date, update };
}
